/**
 * Gerenciador de estado de logout
 * Permite que múltiplos módulos saibam quando estamos em processo de logout
 * e possam ignorar erros relacionados
 */

let isLoggingOut = false;

export const setIsLoggingOut = (value) => {
  isLoggingOut = value;
};

export const getIsLoggingOut = () => {
  return isLoggingOut;
};

const logoutManager = {
  setIsLoggingOut,
  getIsLoggingOut
};

export default logoutManager;
